import React, { useState } from 'react';
import { AppBar, Hidden, Toolbar, IconButton, Tooltip } from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import SupportDialog from 'app/fuse-layouts/shared-components/SupportDialog';
import { useSelector } from 'react-redux';
import QuickJob from 'app/main/job-manager/QuickJob';
import { useLocation, Link } from 'react-router-dom';
import { FuseAnimate } from '@fuse';
import { Icon, Typography } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
	separator: {
		width: 1,
		height: 64,
		backgroundColor: theme.palette.divider
	},
	appBar: {
		backgroundColor: '#2b3245ff',
		opacity: 0.8,
		color: '#f8fafc',
		borderBottom: '1px solid #334155'
	}
}));

const ToolbarLayout = props => {
	const socket = props.socket;
	const toolbarTheme = useSelector(({ fuse }) => fuse.settings.toolbarTheme);
	const role = useSelector(({ auth }) => auth.user.role);
	const themeMode = useSelector(({ modernDashboard }) => modernDashboard?.userPreferences?.themeMode || 'dark');
	const [supportDialogOpen, setSupportDialogOpen] = useState(false);

	const classes = useStyles(props);

	//get path url from validate icon
	const location = useLocation();
	
	// Apply dark theme when user preference is dark mode
	const isDarkMode = themeMode === 'dark';
	
	let iconJob = true;
	let back = '/clusters';
	if (location.pathname === '/account' || location.pathname === '/settings') {
		iconJob = false;
	}

	if (location.pathname === '/account/' + location.pathname.split('/', 3)[2]) {
		iconJob = false;
		back = '/account';
	}

	if (location.pathname === '/account-job/' + location.pathname.split('/', 3)[2]) {
		iconJob = false;
		back = '/account';
	}
	if (location.pathname === '/account-cluster/' + location.pathname.split('/', 3)[2]) {
		iconJob = false;
		back = '/account';
	}

	return (
		<ThemeProvider theme={toolbarTheme}>
			{role.length !== 0 && (
				<AppBar 
					id="fuse-toolbar" 
					className={`flex relative z-10 ${isDarkMode ? classes.appBar : ''}`} 
					color="transparent"
				>
					<Toolbar className="p-0">
						<div className="flex flex-1">
							<Hidden lgUp>
								<NavbarMobileToggleButton className="w-64 h-64 p-0" />
								<div className={classes.separator} />
							</Hidden>
							{iconJob && !role.includes('participant') && <QuickJob />}
							{!iconJob && (
								<FuseAnimate animation="transition.slideRightIn" delay={300}>
									<Typography
										id="back-btn"
										className="normal-case flex items-center"
										role="button"
										color="inherit"
										component={Link}
										to={back}
									>
										<Icon className="mr-4 ml-12 text-20">arrow_back</Icon>
										Back
									</Typography>
								</FuseAnimate>
						)}
					</div>
					<div className="flex items-center">
						{!role.includes('admin') && (
							<Tooltip title="Contact Support" placement="bottom">
								<IconButton 
									onClick={() => setSupportDialogOpen(true)}
									color="inherit"
									style={{ marginRight: 8 }}
								>
									<HelpOutline />
								</IconButton>
							</Tooltip>
						)}
						<UserMenu socket={socket} />
					</div>
				</Toolbar>
				
				<SupportDialog 
					open={supportDialogOpen} 
					onClose={() => setSupportDialogOpen(false)} 
				/>
			</AppBar>
		)}
	</ThemeProvider>
);
};

export default ToolbarLayout;